<template>
  <div
      id="data-list-list-view"
      class="data-list-container"
      v-if="documents"
  >
    <div class="vx-row mt-4 md:flex-row">
      <div class="vx-col w-full">
        <InStorageTable
            :data="documents"
            :itemsPerPage="itemsPerPage"
            @search="search"
            @filter="setFilter"
            @sort="setSort"
            @update="getPage"
        ></InStorageTable>
        <vs-pagination
            description
            goto
            descriptionTitle="Documents"
            :sizeArray="documents.count"
            :description-items="descriptionItems"
            :total="documents.number_of_pages"
            :max-items="itemsPerPage"
            :max="itemsPerPage"
            v-model="pageNumberComputed"
            @changeMaxItems="setItemsPerPage"
        ></vs-pagination>
      </div>

    </div>
  </div>
</template>

<script>
  import InStorageTable from './table'
  import { http } from '@/services'

  export default {
    name: 'DocumentsAll',
    components: {
      InStorageTable
    },
    created () {
      if (this.$route.params.page) this.pageNumber = Number(this.$route.params.page)
      this.getPage()
    },
    beforeRouteUpdate (to, from, next) {
      next()
      if (this.$route.params.page) this.pageNumber = Number(this.$route.params.page)
      this.getPage()
    },
    computed: {
      documentsData () {
        if (this.documents && this.documents.data) return this.documents.data
        return []
      },
      pageNumberComputed: {
        set (value) {
          this.pageNumber = value
          this.getPage()
        },
        get () {
          return this.pageNumber
        }
      }
    },
    data () {
      return {
        documents: null,
        pageNumber: 1,
        itemsPerPage: 10,
        queriedItems: 20,
        filter: 'in_storage',
        sortKey: 'date_created',
        sortActive: 'desc',
        query: null,
        descriptionItems: [10, 20, 50]
      }
    },
    methods: {
      addNewData () {
        console.log('add new data')
      },
      setItemsPerPage (value) {
        this.itemsPerPage = this.descriptionItems[value]
        this.getPage()
      },
      getPage (searchQuery = null) {
        http.get('paper_documents_list', { params: { filter: this.filter, items_per_page: this.itemsPerPage, page_number: this.pageNumber, query: this.query, sort: [this.sortKey, this.sortActive] } }).then(
        response => {
          this.documents = response.data
        }
        ).catch(
        error => {
          console.log(error)
        }
        )
      },
      search (value) {
        this.query = value
        this.getPage()
      },
      setFilter (value) {
        this.filter = value
        this.getPage()
      },
      setSort (key, active) {
        this.sortKey = key
        this.sortActive = active
        if (key) this.getPage()
      }
    }
  }
</script>

<style lang="scss">

</style>
